module.exports = __webpack_public_path__ + "static/ground-truth-dataset-b4c19b48f78f7802e085bce19f9e3f31.png";